/** The small table of the settings an answer changes (screens §P6), opened under "Show the detail of each answer". */
import { GxTermText } from "../theme/GxTerm";
import { GxTable } from "../theme/GxTable";
import type { OptionSetting } from "./sets";

/** "Decision · What it becomes": the settings the option fixes, one row each. */
export function SettingsTable({ settings, testId }: { readonly settings: readonly OptionSetting[]; readonly testId: string }) {
  return (
    <GxTable testId={testId} dense caption="What this answer sets" columns={[{ key: "decision", label: "Decision" }, { key: "becomes", label: "With this answer" }]}
      rows={settings.map((s) => ({ key: `${s.decision}|${s.becomes}`, cells: { decision: <GxTermText>{s.decision}</GxTermText>, becomes: s.becomes } }))} />
  );
}
